import ConciliacionBancaria from "src/pages/ConciliacionBancaria";
import Liquidacion from "src/pages/Liquidacion";

export const TEST_USERS = [
  "192613639",
  "205090851",
  "194467354",
  "121695979",
  "132012636",
  "154157131",
  "193928595",
  "200353102",
];

export const TEST_SUCURSALES = ["CURICO"];

export function buildRoleRoutes({ rut, sucursal, baseRoutes }) {
  const isTestUser = TEST_USERS.includes(rut);
  const isSucursalTest = TEST_SUCURSALES.includes(sucursal);

  if (isTestUser && isSucursalTest) {
    return [
      ...baseRoutes,
      { path: "liquidacion", element: <Liquidacion /> },
      { path: "conciliacion-bancaria", element: <ConciliacionBancaria /> },
    ];
  }
  if (isSucursalTest) {
    return [
      ...baseRoutes,
      { path: "conciliacion-bancaria", element: <ConciliacionBancaria /> },
    ];
  }
  return baseRoutes;
}
